import { Ward } from 'app/modules/system-settings/locations/wards/core/type';

import { IBatchExpiryStatus, RackType } from './enum';
import { RackFilterParams, RackFormType } from './type';

export const RACK_TYPE: RackFormType[] = [
  // {
  //   value: RackType['Smart rack'],
  //   title: RackType[0],
  // },
  {
    value: RackType['Custom rack'],
    title: RackType[0],
  },
];

export const HIGHLIGHT_EXPIRY_STATUS = {
  [IBatchExpiryStatus.NORMAL]: {
    color: 'var(--success)',
    text: 'Expiry OK',
  },
  [IBatchExpiryStatus.WARNING]: {
    color: 'var(--warning-active-2)',
    text: 'Expiry Alert',
  },
  [IBatchExpiryStatus.EXPIRED]: {
    color: 'var(--danger)',
    text: 'Items expired',
  },
};

export const PRIORITY_EXPIRY_STATUS: IBatchExpiryStatus[] = [
  IBatchExpiryStatus.EXPIRED,
  IBatchExpiryStatus.WARNING,
  IBatchExpiryStatus.NORMAL,
];

export const RACK_HAS_BEEN_SYNCED_MSG = 'Rack has been synced.';

export const DEFAULT_RACK_FILTER: RackFilterParams = {
  wardIds: [],
  is_custom: undefined,
  page: 1,
};

export const WARD_OPTION = (wards: Ward[]) =>
  wards.map((ward) => ({
    value: String(ward.id),
    label: ward.name,
  }));

export const SELECTED_WARD = (selectedWardIds: string[], wards: Ward[]) =>
  selectedWardIds.map((wardId) => {
    const ward = wards.find((w) => String(w.id) === wardId);
    return {
      value: String(ward?.id),
      label: ward?.name,
    };
  });

export const CUSTOM_OPTIONS = [
  // { value: 'true', label: 'Non-smart' },
  { value: 'false', label: 'Smart' },
];

export const SELECTED_CUSTOM = (isCustom?: boolean) => {
  if (isCustom === undefined) return [];
  return CUSTOM_OPTIONS.filter((option) => option.value === String(isCustom));
};
